<template>
  <div class="imgEdit-content">
    <heads title="图文编辑" @submit="preview('ruleForm')"></heads>
    <div class="imgEdit-container add-imgText-content">
      <el-scrollbar style="height: 100%">
        <el-form :model="reqData" ref="ruleForm" class="search-form" :rules="rules">
          <el-row :gutter="30">
            <el-col :span="8">
              <div>
                <div class="sub-title">
                  标题图
                  <span>（建议尺寸1078*606像素，图片大小不超过2M）</span>
                </div>
                <div class="upload-box">
                  <el-form-item prop="cover">
                    <upload-cropper @getPath="getPath" :url="reqData.cover" :fixScale="fixScale"></upload-cropper>
                  </el-form-item>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <el-row>
                <div>
                  <div class="sub-title">文章标题</div>
                  <el-form-item prop="articletitle">
                    <el-input v-model="reqData.articletitle" placeholder="请输入文章标题" size="small"></el-input>
                  </el-form-item>
                </div>
              </el-row>
              <el-row>
                <div>
                  <div class="sub-title">简介</div>
                  <el-form-item prop="remark">
                    <el-input
                      type="textarea"
                      placeholder="请输入文章简介"
                      v-model="reqData.remark"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-row>
            </el-col>
          </el-row>
          <el-row>
            <div class="editor-box">
              <el-form-item prop="articlecontent">
                <editor ref="articleEditor" :content="reqData.articlecontent"></editor>
              </el-form-item>
            </div>
          </el-row>
        </el-form>
      </el-scrollbar>
    </div>
    <el-dialog :visible.sync="previewDialog" width="30%" class="priviewDialog">
      <div class="content-title">{{reqData.articletitle}}</div>
      <div v-html="reqData.articlecontent"></div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import heads from "@/components/header.vue";
import uploadCropper from "@/components/uploadCropper.vue";
import editor from "@/components/editor.vue";
import api from "@/api/news/publish.js";
export default {
  components: { heads, uploadCropper, editor },
  data() {
    return {
      fixScale:[332,94],
      previewDialog: false,
      reqData: {
        communityid: -1,
        articletitle: "",
        articlecontent: "",
        cover: "",
        remark:'',
      },
      content: "",
      rules: {
        articletitle: [
          { required: true, message: "请输入文章标题", trigger: "blur" }
        ],
        cover: [
          { required: true, message: "请上传标题图片", trigger: "change" }
        ],
        articlecontent: [
          { required: true, message: "请输入文章内容", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
    userInfo() {
      return this.$store.state.userInfo;
    }
  },
  mounted() {
    if (this.id !== undefined) {
      this.getArticleInfo();
    }
  },
  methods: {
    // 编辑获取活动详情
    async getArticleInfo() {
      let res = await this.$http.get(`${api.articleInfo}?id=${this.id}`);
      if (res && res.isSucceed) {
        let data = res.rows && res.rows.length > 0 ? res.rows[0] : {};
        for (let key in this.reqData) {
          if (data.hasOwnProperty(key)) {
            this.reqData[key] = data[key];
          }
        }
        this.reqData.articletype = Number(data.articletype);
        this.reqData.id = data.id;
      }
    },

    getPath(data) {
      this.reqData.cover = data.path;
    },
    preview(formName) {
      this.reqData.articlecontent = this.$refs.articleEditor.getContent();
      this.$refs[formName].validate(valid => {
        if (!valid) return;
        this.previewDialog = true;
      });
    },
    async submit() {
      this.previewDialog = false;
      this.$message({
        message: "正在保存,请稍等...",
        type: "success"
      });
      let data = JSON.parse(JSON.stringify(this.reqData));
      let res = await this.$http.post(api.saveAndriod, this.$qs.stringify(data));
      if (res && res.isSucceed) {
        this.$router.push("/platformConfig/androidPublish");
        this.$message({
          message: "保存成功",
          type: "success"
        });
      }
    }
  }
};
</script>
<style lang='less' scoped>
.imgEdit-content {
  height: 100%;
}

.imgEdit-container {
  height: calc(100% - 60px);
  padding: 0 0 20px 20px;
  .type-item {
    display: flex;
  }
  .upload-box {
    width: 400px;
  }
  .editor-box {
    width: 90%;
    margin-top: 20px;
  }
}

.content-title {
  text-align: center;
  font-size: 20px;
  color: #000;
  margin-bottom: 20px;
}
</style>
<style lang='less'>
@import url("../../peopleOnline/volunteer/ele-add.less");
.priviewDialog {
  .el-dialog__body {
    height: 600px;
    overflow: auto;
  }
}
</style>